import { useState } from 'react';
import { SEARCH_CONFIG } from '../utils/reportConstants';
import treatmentReportsService from '../../../services/treatmentReportsService';
import { calculateTotals } from '../services/reportCalculations';

export const useServiceSearch = (formData, setFormData) => {
  const [serviceSearch, setServiceSearch] = useState('');
  const [serviceResults, setServiceResults] = useState([]);
  const [showServiceDropdown, setShowServiceDropdown] = useState(false);

  // Search products/services
  const searchServices = async (query) => {
    if (query.length < SEARCH_CONFIG.SERVICE_MIN_LENGTH) {
      setServiceResults([]);
      setShowServiceDropdown(false);
      return;
    }

    try {
      const results = await treatmentReportsService.searchProductsServices(query);
      setServiceResults(results);
      setShowServiceDropdown(true);
    } catch (error) {
      console.error('Error searching services:', error);
    }
  };

  // Handle service selection
  const handleServiceSelect = (service) => {
    const newLineItem = {
      id: Date.now(),
      description: service.sales_description || service.name,
      qty: 1,
      price: service.price || 0,
      total: service.price || 0
    };
    
    const updatedLineItems = [...formData.line_items, newLineItem];
    
    setFormData(prev => ({
      ...prev,
      line_items: updatedLineItems
    }));
    
    setServiceSearch('');
    setServiceResults([]);
    setShowServiceDropdown(false);
    
    // Recalculate totals
    const totals = calculateTotals(updatedLineItems, formData.tax_rate);
    setFormData(prev => ({ ...prev, ...totals }));
  };

  // Update line item
  const updateLineItem = (id, field, value) => {
    const updatedItems = formData.line_items.map(item => {
      if (item.id === id) {
        const updated = { ...item, [field]: value };
        if (field === 'qty' || field === 'price') {
          updated.total = parseFloat(updated.qty || 0) * parseFloat(updated.price || 0);
        }
        return updated;
      }
      return item;
    });
    
    setFormData(prev => ({ ...prev, line_items: updatedItems }));
    
    // Recalculate totals
    const totals = calculateTotals(updatedItems, formData.tax_rate);
    setFormData(prev => ({ ...prev, ...totals }));
  };

  // Remove line item
  const removeLineItem = (id) => {
    const updatedItems = formData.line_items.filter(item => item.id !== id);
    setFormData(prev => ({ ...prev, line_items: updatedItems }));
    
    // Recalculate totals
    const totals = calculateTotals(updatedItems, formData.tax_rate);
    setFormData(prev => ({ ...prev, ...totals }));
  };

  // Update tax rate and recalculate
  const updateTaxRate = (rate) => {
    const newRate = parseFloat(rate) || 0;
    const totals = calculateTotals(formData.line_items, newRate);
    setFormData(prev => ({ 
      ...prev, 
      tax_rate: newRate,
      ...totals 
    }));
  };

  const closeServiceDropdown = () => {
    setShowServiceDropdown(false);
  };

  return {
    serviceSearch,
    setServiceSearch,
    serviceResults,
    showServiceDropdown,
    closeServiceDropdown,
    searchServices,
    handleServiceSelect,
    updateLineItem,
    removeLineItem,
    updateTaxRate
  };
};